import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import BrtxLinkCard from "../../componets/BrtxLinkCard";
import {
  FaGooglePlay,
  FaMoneyBillAlt,
  FaFax,
  FaAward,
  FaSalesforce,
  FaServer,
} from "react-icons/fa";

class Service extends React.Component {
  state = {
    items: [
      {
        title: "Autorizace",
        subtitle: "Autorizace pro uvedené výrobce.",
        link: "/service/support",
        icon: <FaGooglePlay className="c-white" />,
      },
      {
        title: "Bankovní technika",
        subtitle: "Naše společnost zajišťuje servis bankovní techniky",
        link: "/service/banking",
        icon: <FaMoneyBillAlt className="c-white" />,
      },
      {
        title: "Služby na míru",
        subtitle:
          "Nabízíme speciální služby poskytované přímo na míru naším zákazníkům.",
        link: "/service/customizedServices",
        icon: <FaServer className="c-white" />,
      },
      {
        title: "Nejčastější dotazy",
        subtitle: "Zobrazí nejčastější dotazy na naší infolinku.",
        link: "/service/faq",
        icon: <FaFax className="c-white" />,
      },
      {
        title: "Prodej",
        subtitle: "Zobrazí aktuální nabídku.",
        link: "/service/sale",
        icon: <FaSalesforce className="c-white" />,
      },
    ],
  };
  componentDidMount() {
    this.props.setHeaderPage({
      Icon: <FaAward className="c-placeholder c-green" />,
      Title: "Servis",
      SubTitle: "Veškeré informace o servisní činosti naší společnosti.",
    });
  }

  render() {
    return (
      <>
        <Row className="d-flex mb-2">
          {this.state.items.map((i, idx) => (
            <BrtxLinkCard {...this.props} {...i} idx={idx} />
          ))}
        </Row>
      </>
    );
  }
}

export default Service;
